import { surveysUrl } from '@/utils/constants';
import Text from './Text';
import CheckCircle from './icons/CheckCircle';
import { twMerge } from 'tailwind-merge';
import RightArrow from './icons/RightArrow';
import { useEffect } from 'react';
import trackEvent from '@/utils/amplitude';

interface Props {
  checkedIn: boolean;
  appointmentUuid: string;
  extraStyles?: string;
  appointmentTime: string;
  providerNpi: number;
}

const CheckInBanner = ({
  checkedIn,
  appointmentUuid,
  extraStyles,
  appointmentTime,
  providerNpi,
}: Props) => {
  useEffect(() => {
    trackEvent({
      product_area: 'Appointments',
      name: 'checkin_displayed',
      trigger: 'Page load',
      metadata: {
        appointmentTime,
        checkedIn,
      },
    });
  }, []);

  const handleClick = () => {
    if (!checkedIn) {
      trackEvent({
        product_area: 'Appointments',
        name: 'checkin_clicked',
        trigger: 'Interaction',
        metadata: {
          appointmentTime,
          providerNpi,
        },
      });
      window.location.href = `${surveysUrl}/mic/${appointmentUuid}`;
    }
  };

  const contents = checkedIn ? (
    <>
      <Text.P.Bold>Self check-in complete</Text.P.Bold>
      <CheckCircle stroke="sky-50" />
    </>
  ) : (
    <>
      <Text.P.Bold>Complete your self check-in</Text.P.Bold>
      <RightArrow
        className="transition-transform ease-in-out duration-300 group-hover:translate-x-[3px]"
        stroke="sky-50"
      />
    </>
  );

  const classes = checkedIn
    ? 'text-fern-50 bg-fern-10'
    : 'group text-sky-50 bg-sky-10 cursor-pointer transition-colors ease-in-out background-color hover:bg-sky-20';

  return (
    <div
      className={twMerge(
        'w-full h-16 flex justify-between items-center px-9',
        classes,
        extraStyles,
      )}
      onClick={handleClick}
      role={!checkedIn ? 'button' : undefined}
    >
      {contents}
    </div>
  );
};

export default CheckInBanner;
